import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import actions, { internalDatasourceType } from '../constants';
import { findDatasourceTypes } from './state';

const fetchDatasourceTypes = withDraft((draft, action) => {
  const item = findDatasourceTypes(draft, action);
  item.readErrors = [];
  item.results = [internalDatasourceType];
  item.readStatus = states.PENDING;
});

const fetchDatasourceTypesSuccess = withDraft((draft, action) => {
  const item = findDatasourceTypes(draft, action);
  item.readErrors = [];
  item.results = action.result.items;
  item.results.unshift(internalDatasourceType);
  item.readStatus = states.SUCCESS;
});

const fetchDatasourceTypesError = withDraft((draft, action) => {
  const item = findDatasourceTypes(draft, action);
  item.readErrors = [responseError(action)];
  item.results = [];
  item.readStatus = states.ERROR;
});

export default {
  [actions.FETCH_DATASOURCE_TYPES]: fetchDatasourceTypes,
  [actions.FETCH_DATASOURCE_TYPES_ERROR]: fetchDatasourceTypesError,
  [actions.FETCH_DATASOURCE_TYPES_SUCCESS]: fetchDatasourceTypesSuccess,
};
